import { coerceToDate } from '@chatwoot/utils';
import parseISO from 'date-fns/parseISO';

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/**
 * `coerceToDate` reads a bare 'YYYY-MM-DD' as UTC midnight and then re-anchors it with a local
 * `setHours(0, 0, 0, 0)`, landing on the previous day in every timezone behind UTC. `parseISO`
 * keeps it on the day that was picked. Other shapes stay with `coerceToDate`: `parseISO` rejects
 * the bare epoch strings the API sends.
 *
 * A saved filter (custom view/folder) persists its query through `filterQueryGenerator`, which
 * wraps every `values` in an array before it is stored. When that stored payload is re-applied
 * client-side, the date arrives as `['2026-09-04']` instead of the bare string an ad-hoc filter
 * passes, so it must be unwrapped before the date-only check below can see it.
 *
 * @returns {Date|null} - null for values that are not dates; callers must check
 */
export const toComparableDate = value => {
  const candidate = Array.isArray(value) ? value[0] : value;

  if (typeof candidate === 'string' && DATE_ONLY_REGEX.test(candidate)) {
    return parseISO(candidate);
  }

  return coerceToDate(candidate);
};

export default toComparableDate;
